import { quotaToString } from '../../cost'
import { areaToString } from '../../units'

const quotaName = {
  project: ['', 'upload'],
  plant_count: ['', 'plant count'],
  credit: ['€', ''],
}

export function costToString(
  {
    totals,
    meta: {
      cost_units: costUnits,
      cost_variable: costVariable,
      captures_per_unit: capturesPerUnit,
      area_per_unit: areaPerUnit,
      currency_symbol: currencySymbol,
    },
    units,
  },
  emptyWhenDefault = true
) {
  // Don't show if cost is 1 (which is the "normal" cost)
  const showCost = !emptyWhenDefault || costUnits > 1

  if (showCost) {
    const costKeys = Object.keys(totals)
    const costVariableStr =
      costVariable === 'captures' ? 'the number of captures' : 'the area'
    const costLimit =
      costVariable === 'captures' ? capturesPerUnit : areaPerUnit
    const costKey = costKeys.find(q => totals[q].amount > 0)
    const costLimitStr =
      costVariable === 'captures'
        ? costLimit
        : areaToString(costLimit, units, {})

    return `This upload will ${
      costKey === 'project' ? 'count as' : 'use'
    } ${quotaToString(
      costKey,
      totals[costKey].amount,
      currencySymbol,
      true,
      0
    )} because ${costVariableStr} exceeds ${costLimitStr}.`
  } else {
    return null
  }
}

export function insufficientQuotaMessage({ totals }) {
  const firstInsufficient = Object.keys(totals).find(k => !totals[k].sufficient)
  if (firstInsufficient) {
    if (firstInsufficient !== 'credit') {
      return `You don't have enough ${quotaName[firstInsufficient][1]}s or credit remaining.`
    } else {
      return `You don't have enough credit remaining.`
    }
  } else {
    return null
  }
}

export function costHasInsufficientQuota({ totals }) {
  return Object.values(totals).some(c => !c.sufficient)
}
